import type {
  ReportingSummaryFilterOptions,
  ReportingSummaryFiltersValue,
} from "../../queries/sportsbook/reportingSummaryFilterOptions";
import { REPORTING_SUMMARY_FILTER_KEYS } from "../../queries/sportsbook/reportingSummaryFilterOptions";

export function createAllReportingSummaryFilters(): ReportingSummaryFiltersValue {
  return REPORTING_SUMMARY_FILTER_KEYS.reduce<ReportingSummaryFiltersValue>(
    (filters, key) => {
      filters[key] = ["all"];
      return filters;
    },
    {} as ReportingSummaryFiltersValue,
  );
}

export function normalizeReportingSummaryMultiSelectValue(
  current: string[],
  next: string[],
): string[] {
  if (!next.includes("all")) return next;
  if (current.includes("all") && next.length > 1) {
    return next.filter((value) => value !== "all");
  }
  return ["all"];
}

/** Builds the initial draft/applied values from the backend-provided defaults. */
export function initialFiltersFromOptions(
  options: ReportingSummaryFilterOptions,
): ReportingSummaryFiltersValue {
  return REPORTING_SUMMARY_FILTER_KEYS.reduce<ReportingSummaryFiltersValue>(
    (acc, key) => {
      acc[key] = [...options[key].defaultSelected];
      return acc;
    },
    {} as ReportingSummaryFiltersValue,
  );
}

function sameStringSet(a: string[], b: string[]): boolean {
  if (a.length !== b.length) return false;
  const sortedA = [...a].sort();
  const sortedB = [...b].sort();
  return sortedA.every((value, idx) => value === sortedB[idx]);
}

/** Order-insensitive dirty check across every filter group. */
export function isReportingSummaryFiltersDirty(
  draft: ReportingSummaryFiltersValue,
  applied: ReportingSummaryFiltersValue,
): boolean {
  return REPORTING_SUMMARY_FILTER_KEYS.some(
    (key) => !sameStringSet(draft[key], applied[key]),
  );
}

